import { useContext } from 'react';
import UserDoc from '../../../domain/models/UserDoc';
import { useWindowSize } from '@leedpulse-monorepo/hooks';
import { Avatar, Button, Popconfirm, Table } from 'antd';
import { userRoleAsString, userTypeAsString, ContextStatus, getBestUserType, UserType } from '@leedpulse-monorepo/enums';
import { MinusCircleOutlined } from '@ant-design/icons';
import SubscriptionsContext from '../../contexts/data/SubscriptionsContext';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import UserPartnerLogo from '../user_partner_logo/UserPartnerLogo';
import { USERS_PAGE_PATH } from '../../pages/users/UsersPage';
import { advancedOnRow } from '../../../core/utils/commonUtils';

interface SubscriptionUsersListProps {
  users: UserDoc[];
}

const SubscriptionUsersList: React.FC<SubscriptionUsersListProps> = ({ users }) => {
  const windowSize = useWindowSize();
  const navigate = useNavigate();
  const subscriptionsContext = useContext(SubscriptionsContext);

  return (
    <Table
      pagination={false}
      columns={
        windowSize.width > 576
          ? [
            {
              title: 'Avatar',
              dataIndex: 'avatar',
              key: 'avatar',
              render: (avatar: string) => <Avatar src={avatar} size={'small'} />,
            },
            {
              title: 'Utilisateur',
              render: (record: UserDoc) => (<><UserPartnerLogo partnerSystem={record?.partnerSystem} /> {record?.firstname} {record?.lastname} </>),
            },
            {
              title: 'Email',
              dataIndex: 'email',
              key: 'email',
            },
            {
              title: 'Dernière connexion',
              dataIndex: 'last_login',
              key: 'last_login',
              render: (_: number, oUser: UserDoc) => {
                let color = 'gray';

                if (oUser.last_login !== oUser.created) {
                  color = oUser.last_login === 0 || moment(oUser.last_login).isBefore(moment().subtract(1, 'month'))
                    ? 'red'
                    : oUser.last_login === 0 || moment(oUser.last_login).isBefore(moment().subtract(1, 'week'))
                      ? 'orange'
                      : 'green';
                }

                return <span style={{ color }}>{oUser.last_login === oUser.created ? `Jamais connecté(e)` : `Dernière connexion ${moment(oUser.last_login).fromNow()}`}</span>;
              },
            },
            {
              title: 'Droits',
              key: 'type',
              render: (record: UserDoc) => userTypeAsString(getBestUserType(record.idSubscription[subscriptionsContext.selected?.id as string]?.roles as UserType[] || [])),
            },
            {
              title: 'Rôle',
              dataIndex: 'role',
              key: 'role',
              render: (role: string) => userRoleAsString(role),
            },
            {
              title: '',
              dataIndex: 'emailAuthentication',
              key: 'emailAuthentication',
              render: (emailAuthentication: string) => (
                <Popconfirm
                  title="Êtes-vous sûr de vouloir retirer cet utilisateur de l'abonnement ?"
                  onCancel={(e) => e?.stopPropagation()}
                  onConfirm={(e) => {
                    e?.stopPropagation();
                    subscriptionsContext.removeUser(emailAuthentication);
                  }}
                  okText="Oui"
                  cancelText="Non"
                >
                  <Button
                    icon={<MinusCircleOutlined style={{ color: '#FF0000' }} />}
                    type="text"
                    loading={subscriptionsContext.statusAddRemoveUser === ContextStatus.LOADING}
                    onClick={(e) => e.stopPropagation()}
                  />
                </Popconfirm>
              ),
            },
          ]
          : [
            {
              title: 'Email',
              dataIndex: 'email',
              key: 'email',
            },
          ]
      }
      rowKey={(record) => record.uid}
      dataSource={users}
      onRow={(record) =>
        advancedOnRow({
          url: `${USERS_PAGE_PATH}/${record.uid}`,
          navigate,
          className: 'table-row',
        })
      }
    />
  );
};

export default SubscriptionUsersList;
